export default __webpack_public_path__ + "static/media/checked.a24ddd54.svg";